// extracted by mini-css-extract-plugin
export var resizer = "_ej-0";